export default __webpack_public_path__ + "static/media/caspergreen.fc46bf07.svg";